import React from 'react';

const Reviews = () => {
    return (
        <div>
            <h1>This is Reviews</h1>
        </div>
    );
};

export default Reviews;